/**
 * Operator Arity Map
 *
 * Defines how many values each operator requires:
 * - 0: Unary operators (no value needed)
 * - 1: Single-value operators (exactly one value)
 * - 'many': List operators (one or more values)
 */
export const OPERATOR_ARITY = {
  // Equality operators
  '=': 1,
  '!=': 1,
  '==': 1,
  '<>': 1,

  // Comparison operators
  '>': 1,
  '<': 1,
  '>=': 1,
  '<=': 1,

  // String operators
  contains: 1,
  startsWith: 1,
  endsWith: 1,
  like: 1,
  iLike: 1,

  // List operators
  in: 'many',
  notIn: 'many',

  // Unary operators
  isEmpty: 0,
  isNotEmpty: 0,
  isNull: 0,
  isNotNull: 0,

  // Date-specific relative operators (UI-only, resolved before hitting backend)
  moreThanDaysAgo: 1,
  lessThanDaysAgo: 1,

  // Date-specific UI operator (expands to >= / <= predicates in AST)
  between: 'many'
};

/**
 * Get arity for an operator
 * @param {string} operator - Operator name
 * @returns {0|1|'many'} Operator arity
 */
export function getOperatorArity(operator) {
  if (!(operator in OPERATOR_ARITY)) {
    // Central warning for unknown operators so schema or UI issues are visible
    console.warn(`Unknown operator: ${operator}, defaulting to arity 1`);
  }
  return OPERATOR_ARITY[operator] ?? 1;
}

/**
 * Check if operator requires no value
 * @param {string} operator
 * @returns {boolean}
 */
export function isUnaryOperator(operator) {
  return getOperatorArity(operator) === 0;
}

/**
 * Check if operator requires exactly one value
 * @param {string} operator
 * @returns {boolean}
 */
export function isSingleValueOperator(operator) {
  return getOperatorArity(operator) === 1;
}

/**
 * Check if operator accepts multiple values
 * @param {string} operator
 * @returns {boolean}
 */
export function isListOperator(operator) {
  return getOperatorArity(operator) === 'many';
}



